/**
 * en-GB messages added by Phase 4 task S48 (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s48EnGB = {
    'email.api-clients.expiry_warning.subject': '{tenant}: the API key for {client} runs out in {daysLeft} days',
    'email.api-clients.expiry_warning.body': 'The API key for "{client}" runs out on {expiryDate} ({daysLeft} days from now). After that, the system using it will stop working. To keep it running, open Manage, then API clients, and either set a later expiry date or create a new key.',
    'error.api_client_expiry_past': 'Choose an expiry date in the future.',
};
//# sourceMappingURL=s48.js.map